import { render, staticRenderFns } from "./card-cedrow-grid-icons.vue?vue&type=template&id=2241d48e&scoped=true&"
import script from "./card-cedrow-grid-icons.vue?vue&type=script&lang=js&"
export * from "./card-cedrow-grid-icons.vue?vue&type=script&lang=js&"
import style0 from "./card-cedrow-grid-icons.vue?vue&type=style&index=0&id=2241d48e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241d48e",
  null
  
)

export default component.exports